import { BaseAPIModel, fetcher } from '@weezevent/weezjs-core';

export default class ModerationFlows extends BaseAPIModel {
    fields() {
        return {
            name: {},
            id: { primaryKey: true, readOnly: true }
        };
    }

    static listUrl({ organizationId }) {
        return `/ticket/organizations/${organizationId}/moderation_flows`;
    }

    unlinkEvent({ eventId, organizationId }) {
        return fetcher
            .post(`/ticket/organizations/${organizationId}/moderation_flows/${this.pk}/unlink_event`, {
                data: { event_id: eventId }
            })
            .then(resp => resp)
            .catch(e => e);
    }

    static duplicate({ flowId, organizationId, datas }) {
        return fetcher
            .post(`/ticket/organizations/${organizationId}/moderation_flows/${flowId}/duplicate`, {
                data: { ...datas }
            })
            .then(resp => resp)
            .catch(e => e)
            .finally(resp => resp);
    }

    static archive({ flowId, organizationId, datas }) {
        return fetcher.post(`/ticket/organizations/${organizationId}/moderation_flows/${flowId}/archive`, {
            data: { ...datas }
        });
    }

    static unarchive({ flowId, organizationId, datas }) {
        return fetcher.post(`/ticket/organizations/${organizationId}/moderation_flows/${flowId}/unarchive`, {
            data: { ...datas }
        });
    }

    toOptions() {
        return {
            key: this.name,
            text: this.name,
            name: String(this.id),
            value: String(this.id)
        };
    }
}
